import { Stack } from "@mui/material";
import type { FC, ReactNode } from "react";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import DownloadParticipantListTemplateButton from "./DownloadParticipantListTemplateButton";
import UploadParticipantListButton from "./UploadParticipantListButton";
import { getParticipantListTemplateXlsx, getParticipantListTemplateXlsxWithSignedLink } from "./participantListApi";

interface Props {
  readonly orderId: string;
  readonly orderUserFriendlyId: number;
  readonly signedLinkToken?: string;
  readonly onBackToOrder?: () => void;
  readonly editMode: boolean;
  readonly onCancelEdit: () => void;
  readonly onReset: () => void;
  readonly onSave: () => Promise<void>;
  readonly onUploadSpreadsheet: (file: File) => Promise<void>;
  readonly submitEnabled: boolean;
  readonly shareButton?: ReactNode;
}

const ParticipantListEditorActionBar: FC<Props> = ({
  orderId,
  orderUserFriendlyId,
  signedLinkToken,
  onBackToOrder,
  editMode,
  onCancelEdit,
  onReset,
  onSave,
  onUploadSpreadsheet,
  submitEnabled,
  shareButton,
}) => (
  <Stack direction="row" spacing={2}>
    {onBackToOrder ? <CancelButton onClick={onBackToOrder}>Wróć do zamówienia</CancelButton> : null}
    {editMode ? <CancelButton onClick={onCancelEdit}>Anuluj</CancelButton> : null}
    <CancelButton onClick={onReset}>Wyczyść</CancelButton>
    <DownloadParticipantListTemplateButton
      buttonText="Pobierz szablon"
      filename={`${orderUserFriendlyId} - szablon listy.xlsx`}
      getFile={() =>
        signedLinkToken
          ? getParticipantListTemplateXlsxWithSignedLink(orderId, signedLinkToken)
          : getParticipantListTemplateXlsx(orderId)
      }
    />
    <UploadParticipantListButton onUpload={onUploadSpreadsheet} />
    {shareButton}
    <AsyncLoadingButton onClick={onSave} disabled={!submitEnabled}>
      Aktualizuj listę
    </AsyncLoadingButton>
  </Stack>
);

export default ParticipantListEditorActionBar;
